<template>
  <v-btn
    :class="$style.btnTextStyle"
    :absolute="absolute"
    :active-class="activeClass"
    :append="append"
    :block="block"
    :bottom="bottom"
    :color="color"
    :dark="dark"
    :depressed="depressed"
    :disabled="disabled"
    :exact="exact"
    :exact-active-class="exactActiveClass"
    :fab="fab"
    :fixed="fixed"
    :flat="flat"
    :href="href"
    :icon="icon"
    :input-value="inputValue"
    :large="large"
    :left="left"
    :light="light"
    :loading="loading"
    :nuxt="nuxt"
    :outline="outline"
    :replace="replace"
    :right="right"
    :ripple="ripple"
    :round="round"
    :small="small"
    :tag="tag"
    :target="target"
    :to="to"
    :top="top"
    :type="type"
    @click="onClick"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
import ice from "../../../lib/ice";

export default {
  name: "vc-share-link-btn",
  props: {
    absolute: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: "v-btn--active"
    },
    append: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: undefined
    },
    dark: {
      type: Boolean,
      default: false
    },
    depressed: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    exact: {
      type: Boolean,
      default: false
    },
    exactActiveClass: {
      type: String,
      default: undefined
    },
    fab: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: undefined
    },
    icon: {
      type: Boolean,
      default: false
    },
    inputValue: {
      default: undefined
    },
    large: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    nuxt: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    replace: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    ripple: {
      type: [Boolean, Object],
      default: undefined
    },
    round: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "button"
    },
    target: {
      type: String,
      default: undefined
    },
    to: {
      type: [String, Object],
      default: undefined
    },
    top: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "button"
    }
  },
  methods: {
    onClick(event) {
      ice.onClickLink(event);
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
}
</style>
